import React, {useEffect, useState} from "react";
import {useAuth} from "../../authprovider";
import FilesCard from "../building/FilesCard";
import Navigationbar from "../Navigationbar";
import { useTranslation } from 'react-i18next';

export default function FilesManager(props){

    const {buildings, user} = useAuth();
    const [building, setBuilding] = useState(undefined)
    const { t } = useTranslation();

    useEffect(()=>{
        if(building === undefined && user.hasBuilding){
            buildings.getBuilding(user.building, response=>{
                const {success, error, content} = response;

                if(success === true){
                    setBuilding(content)
                } else
                    console.log(error)
            })
        }
    })



    return (
        <>
            <Navigationbar/>
            <div className={"container"}>
                {t('nav.files')}
                {
                    building && <FilesCard data-building={building} />
                }

            </div>
        </>

    )
}